import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/fighters/categories', { params })
  },
  store (formData) {
    return apiClient.post('/fighters/categories', formData)
  },
  show (id, params) {
    return apiClient.get(`/fighters/categories/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/fighters/categories/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/fighters/categories/${id}`)
  }
}
